export const NATIONALITIES = {
  AU: "AU",
  BR: "BR",
  CA: "CA",
  CH: "CH",
  DE: "DE",
  DK: "DK",
  ES: "ES",
  FI: "FI",
  FR: "FR",
  GB: "GB",
  IE: "IE",
  IR: "IR",
  NO: "NO",
  NL: "NL",
  NZ: "NZ",
  TR: "TR",
  US: "US",
};
export const NATIONALITIES_HUMANE_NAME = {
    [NATIONALITIES.AU]: "Australian",
    [NATIONALITIES.BR]: "Brazilian",
    [NATIONALITIES.CA]: "Canadian",
    [NATIONALITIES.CH]: "Czech",
    [NATIONALITIES.DE]: "German",
    [NATIONALITIES.DK]: "Danish",
    [NATIONALITIES.ES]: "Spanish",
    [NATIONALITIES.FI]: "Finnish",
    [NATIONALITIES.FR]: "French",
    [NATIONALITIES.GB]: "British",
    [NATIONALITIES.IE]: "Irish",
    [NATIONALITIES.IR]: "Iranian",
    [NATIONALITIES.NO]: "Norwegian",
    [NATIONALITIES.NL]: "Dutch",
    [NATIONALITIES.NZ]: "New Zealand",
    [NATIONALITIES.TR]: "Turkish",
    [NATIONALITIES.US]: "American",

}